import StubPage from '../../components/StubPage.jsx';

export default function DeveloperPage() {
  return (
    <StubPage
      title="Developer & advanced"
      description="Custom code, headless CMS, automations, and CLI access."
      planned={[
        'Custom <head> and global script injection per site',
        'Headless CMS endpoints for any block tree',
        'Visual database builder (collections + relations)',
        'Automation workflows triggered by events',
        'CLI for backups, migrations, and Git-based deploys',
      ]}
    />
  );
}
